import React, { useState } from "react";

export default function Accordion() {
  const [activeIndex, setActiveIndex] = useState(null);

  const Title = true
const questions = [
  [
    {
      icon: "ti-search",
      question: "¿Cómo agiliza Selektiando el proceso de reclutamiento?",
      answer:
        "Nuestra plataforma utiliza inteligencia artificial para filtrar y seleccionar candidatos de forma automática, reduciendo los tiempos hasta en un 60%.",
    },
    {
      icon: "ti-user",
      question: "¿Qué tipo de perfiles puedo contratar a través de Selektiando?",
      answer:
        "Cualquier puesto que requiera tu operación: Ayudante Generales, Soldadores, Almacenistas, Montacarguistas, Supervisores, etc. El puesto que requieras de las diferentes áreas de tu empresa: Recursos Humanos, Compras, Logistica, Comercial, Marketing, Contabilidad y Finanzas.",
    },
    {
      icon: "ti-settings",
      question: "¿Puedo adaptar el proceso de selección a las necesidades de mi empresa?",
      answer:
        "Sí. Nuestra solución es flexible y permite configurar filtros, etapas y validaciones según tu proceso interno.",
    },
        {
      icon: "ti-money", // representa precio/costos
      question: "¿Cuánto cuesta el servicio?",
      answer:
        "Se genera una cotización a la medida, de acuerdo a los requisitos del cliente. Puesto vacante, cuantas vacantes son, sueldo mensual bruto, prestaciones que ofrecen, lugar de trabajo y perfil de la vacante (Sexo, escolaridad, experiencia).",
    },
    {
      icon: "ti-pencil-alt", // contratar, iniciar proceso
      question: "¿Cómo contratar el servicio?",
      answer:
        "Una vez autorizada la cotización se solicita firmarla como VoBo y compartir documentos para crear el expediente como cliente.",
    },
    {
      icon: "ti-receipt", // facturación
      question: "¿Cuándo se factura el servicio?",
      answer:
        "El Servicio se factura al momento de la contratación del candidato seleccionado por el cliente.",
    },
  ],
  [
    {
      icon: "ti-bar-chart",
      question: "¿Qué tipo de reportes puedo obtener de la plataforma?",
      answer:
        "Obtienes métricas en tiempo real sobre vacantes, candidatos filtrados, tiempo de respuesta, entre otros indicadores clave.",
    },
    {
      icon: "ti-lock",
      question: "¿Mi información y la de los candidatos está protegida?",
      answer:
        "Sí, cumplimos con las normativas de protección de datos y toda la información es almacenada de forma segura.",
    },
    {
      icon: "ti-headphone-alt",
      question: "¿Qué tipo de soporte ofrecen?",
      answer:
        "Contamos con soporte técnico y consultoría especializada vía chat, correo electrónico y WhatsApp.",
    },
        {
      icon: "ti-hand-open", // contratación directa
      question: "¿Puedo contratar directamente al candidato que me guste?",
      answer:
        "¡Sí! El cliente contrata directamente bajo sus lineamientos organizacionales. Selektiando se encarga de encontrar al talento que necesitas.",
    },
        {
      icon: "ti-briefcase", // perfiles y vacantes
      question: "¿Qué tipo de perfiles puedo contratar a través de Selektiando?",
      answer:
        "Cualquier puesto que requiera tu operación: Ayudantes Generales, Soldadores, Almacenistas, Montacarguistas, Supervisores, etc. El puesto que requieras de las diferentes áreas de tu empresa: Recursos Humanos, Compras, Logística, Comercial, Marketing, Contabilidad y Finanzas.",
    }
  ],
];


  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section id="PreguntasFrequentes" className={`container accordions ptb-100`}>
      {Title && (
        <div className="row">
          <div className="col-lg-8 col-md-9">
            <div className="section-heading mb-5">
              <h2>Preguntas Frecuentes</h2>
              <p className="lead">
                Aquí encontrarás las dudas más comunes sobre nuestros servicios.
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="row">
        {questions.map((column, colIndex) => (
          <div className="col-lg-6" key={`col-${colIndex}`}>
            <div className="accordion accordion-faq">
              {column.map((q, i) => {
                const index = `${colIndex}-${i}`;
                const isOpen = activeIndex === index;
                return (
                  <div className="card" key={index}>
                    <div
                      className="card-header py-4"
                      role="button"
                      onClick={() => toggle(index)}
                    >
                      <h6 className="mb-0">
                        <span className={`mr-3 color-secondary ${q.icon}`}></span>
                        {q.question}
                      </h6>
                    </div>
                    {isOpen && (
                      <div className="card-body">
                        <p>{q.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
